module.exports = __webpack_public_path__ + "ad7f12b50332f7520306e6d4f9adca01.png";